import { ObjectManagerComponentBase } from '../object-manager/object-manager.base';
import { ModelBase } from '../../model/model-base';
import { DataService } from '../../service/base/data.service';
import { MessageService } from '../../service/message.service';
import { MenuItemDefinition } from '../../model/menu-item-definition';
import { CommandDispatcher } from '../../service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../service/command/command-handler-resolver.service';
import { NavigationService } from '../../service/navigation.service';
import { SidebarService } from '../../service/sidebar.service';

export abstract class MultiselectObjectManagerComponentBase<TModel extends ModelBase> extends ObjectManagerComponentBase<TModel> {
  constructor(
    dataService: DataService<TModel>,
    dispatcher: CommandDispatcher,
    handlerResolver: CommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService,
    sidebarService?: SidebarService
  ) {
    super(dataService, messageService, navigationService, dispatcher, handlerResolver, sidebarService);
  }

  preferencesKey: string;
  menuDefinition: MenuItemDefinition[] = [];
  defaultFilters: string[] = [];

  addMultiselectMenuItem(caption: string, commandName: string): void {
    if (!this.menuDefinition.find(item => item.commandId == commandName))
      this.menuDefinition.push(new MenuItemDefinition(caption, commandName, null, null, this.contextId));
  }
}
